import * as SportType from 'constants/SportType';
import * as Period from 'constants/Period';
import * as MatchScoreType from 'constants/MatchScore';

//import GENERIC_SCORE_MAP from '../sportGlossary/Generic/ScoreMap';

import BADMINTON_PERIOD_MAP from '../sportGlossary/Badminton/PeriodMap';
import BADMINTON_SCORE_MAP from '../sportGlossary/Badminton/ScoreMap';
import BADMINTON_GROUP_MAP from '../sportGlossary/Badminton/GroupMap';

import BANDY_PERIOD_MAP from '../sportGlossary/Bandy/PeriodMap';
import BANDY_SCORE_MAP from '../sportGlossary/Bandy/ScoreMap';
import BANDY_GROUP_MAP from '../sportGlossary/Bandy/GroupMap';

import BASKETBALL_PERIOD_MAP from '../sportGlossary/Basketball/PeriodMap';
import BASKETBALL_SCORE_MAP from '../sportGlossary/Basketball/ScoreMap';
import BASKETBALL_GROUP_MAP from '../sportGlossary/Basketball/GroupMap';

import BASKETBALL_NCAA_PERIOD_MAP from '../sportGlossary/BasketballNCAA/PeriodMap';
import BASKETBALL_NCAA_GROUP_MAP from '../sportGlossary/BasketballNCAA/GroupMap';
import BASKETBALL_NCAA_SCORE_MAP from '../sportGlossary/BasketballNCAA/ScoreMap';

import BEACH_VOLLEYBALL_PERIOD_MAP from '../sportGlossary/BeachVolleyball/PeriodMap';
import BEACH_VOLLEYBALL_GROUP_MAP from '../sportGlossary/BeachVolleyball/GroupMap';
import BEACH_VOLLEYBALL_SCORE_MAP from '../sportGlossary/BeachVolleyball/ScoreMap';

import BIATHLON_GROUP_MAP from '../sportGlossary/Biathlon/GroupMap';
import BIATHLON_PERIOD_MAP from '../sportGlossary/Biathlon/PeriodMap';
import BIATHLON_SCORE_MAP from '../sportGlossary/Biathlon/ScoreMap';

import BOXING_GROUP_MAP from '../sportGlossary/Boxing/GroupMap';
import BOXING_PERIOD_MAP from '../sportGlossary/Boxing/PeriodMap';
import BOXING_SCORE_MAP from '../sportGlossary/Boxing/ScoreMap';

import CYBERSPORTDOTA2_PERIOD_MAP from '../sportGlossary/CyberSportDota2/PeriodMap';
import CYBERSPORTDOTA2_GROUP_MAP from '../sportGlossary/CyberSportDota2/GroupMap';
import CYBERSPORTDOTA2_SCORE_MAP from '../sportGlossary/CyberSportDota2/ScoreMap';

import FOOTBALL_PERIOD_MAP from '../sportGlossary/Football/PeriodMap';
import FOOTBALL_SCORE_MAP from '../sportGlossary/Football/ScoreMap';
import FOOTBALL_GROUP_MAP from '../sportGlossary/Football/GroupMap';

import HANDBALL_PERIOD_MAP from '../sportGlossary/Handball/PeriodMap';
import HANDBALL_SCORE_MAP from '../sportGlossary/Handball/ScoreMap';
import HANDBALL_GROUP_MAP from '../sportGlossary/Handball/GroupMap';

import ICE_HOCKEY_PERIOD_MAP from '../sportGlossary/IceHockey/PeriodMap';
import ICE_HOCKEY_SCORE_MAP from '../sportGlossary/IceHockey/ScoreMap';
import ICE_HOCKEY_GROUP_MAP from '../sportGlossary/IceHockey/GroupMap';

import TABLE_TENNIS_PERIOD_MAP from '../sportGlossary/TableTennis/PeriodMap';
import TABLE_TENNIS_GROUP_MAP from '../sportGlossary/TableTennis/GroupMap';
import TABLE_TENNIS_SCORE_MAP from '../sportGlossary/TableTennis/ScoreMap';

import TENNIS_PERIOD_MAP from '../sportGlossary/Tennis/PeriodMap';
import TENNIS_SCORE_MAP from '../sportGlossary/Tennis/ScoreMap';
import TENNIS_GROUP_MAP from '../sportGlossary/Tennis/GroupMap';

import VOLLEYBALL_PERIOD_MAP from '../sportGlossary/Volleyball/PeriodMap';
import VOLLEYBALL_GROUP_MAP from '../sportGlossary/Volleyball/GroupMap';
import VOLLEYBALL_SCORE_MAP from '../sportGlossary/Volleyball/ScoreMap';

import WATERPOLO_PERIOD_MAP from '../sportGlossary/Waterpolo/PeriodMap';
import WATERPOLO_GROUP_MAP from '../sportGlossary/Waterpolo/GroupMap';
import WATERPOLO_SCORE_MAP from '../sportGlossary/Waterpolo/ScoreMap';

import WHATWHEREWHEN_PERIOD_MAP from '../sportGlossary/WhatWhereWhen/PeriodMap';
import WHATWHEREWHEN_GROUP_MAP from '../sportGlossary/WhatWhereWhen/GroupMap';
import WHATWHEREWHEN_SCORE_MAP from '../sportGlossary/WhatWhereWhen/ScoreMap';

import MARTIAL_ART_PERIOD_MAP from '../sportGlossary/MartialArt/PeriodMap';
import MARTIAL_ART_GROUP_MAP from '../sportGlossary/MartialArt/GroupMap';
import MARTIAL_ART_SCORE_MAP from '../sportGlossary/MartialArt/ScoreMap';

const sportGroupMap = {};
sportGroupMap[SportType.BADMINTON] = BADMINTON_GROUP_MAP;
sportGroupMap[SportType.BANDY] = BANDY_GROUP_MAP;
sportGroupMap[SportType.BASKETBALL] = BASKETBALL_GROUP_MAP;
sportGroupMap[SportType.BASKTBALL_NCAA] = BASKETBALL_NCAA_GROUP_MAP;
sportGroupMap[SportType.BEACH_VOLLEYBALL] = BEACH_VOLLEYBALL_GROUP_MAP;
sportGroupMap[SportType.BIATHLON] = BIATHLON_GROUP_MAP;
sportGroupMap[SportType.BOX] = BOXING_GROUP_MAP;
sportGroupMap[SportType.CYBER_SPORTS_DOTA2] = CYBERSPORTDOTA2_GROUP_MAP;
sportGroupMap[SportType.FOOTBALL] = FOOTBALL_GROUP_MAP;
sportGroupMap[SportType.HANDBALL] = HANDBALL_GROUP_MAP;
sportGroupMap[SportType.ICE_HOCKEY] = ICE_HOCKEY_GROUP_MAP;
sportGroupMap[SportType.TABLE_TENNIS] = TABLE_TENNIS_GROUP_MAP;
sportGroupMap[SportType.TENNIS] = TENNIS_GROUP_MAP;
sportGroupMap[SportType.VOLLEYBALL] = VOLLEYBALL_GROUP_MAP;
sportGroupMap[SportType.WATER_POLLO] = WATERPOLO_GROUP_MAP;
sportGroupMap[SportType.WHAT_WHERE_WHEN] = WHATWHEREWHEN_GROUP_MAP;
sportGroupMap[SportType.MARTIAL_ARTS] = MARTIAL_ART_GROUP_MAP;

const sportPeriodMap = {};
sportPeriodMap[SportType.BADMINTON] = BADMINTON_PERIOD_MAP;
sportPeriodMap[SportType.BANDY] = BANDY_PERIOD_MAP;
sportPeriodMap[SportType.BASKETBALL] = BASKETBALL_PERIOD_MAP;
sportPeriodMap[SportType.BASKTBALL_NCAA] = BASKETBALL_NCAA_PERIOD_MAP;
sportPeriodMap[SportType.BEACH_VOLLEYBALL] = BEACH_VOLLEYBALL_PERIOD_MAP;
sportPeriodMap[SportType.BIATHLON] = BIATHLON_PERIOD_MAP;
sportPeriodMap[SportType.BOX] = BOXING_PERIOD_MAP;
sportPeriodMap[SportType.CYBER_SPORTS_DOTA2] = CYBERSPORTDOTA2_PERIOD_MAP;
sportPeriodMap[SportType.FOOTBALL] = FOOTBALL_PERIOD_MAP;
sportPeriodMap[SportType.HANDBALL] = HANDBALL_PERIOD_MAP;
sportPeriodMap[SportType.ICE_HOCKEY] = ICE_HOCKEY_PERIOD_MAP;
sportPeriodMap[SportType.TABLE_TENNIS] = TABLE_TENNIS_PERIOD_MAP;
sportPeriodMap[SportType.TENNIS] = TENNIS_PERIOD_MAP;
sportPeriodMap[SportType.VOLLEYBALL] = VOLLEYBALL_PERIOD_MAP;
sportPeriodMap[SportType.WATER_POLLO] = WATERPOLO_PERIOD_MAP;
sportPeriodMap[SportType.WHAT_WHERE_WHEN] = WHATWHEREWHEN_PERIOD_MAP;
sportPeriodMap[SportType.MARTIAL_ARTS] = MARTIAL_ART_PERIOD_MAP;

const scoreRepresentation = {};
scoreRepresentation[SportType.BADMINTON] = BADMINTON_SCORE_MAP;
scoreRepresentation[SportType.BANDY] = BANDY_SCORE_MAP;
scoreRepresentation[SportType.BASKETBALL] = BASKETBALL_SCORE_MAP;
scoreRepresentation[SportType.BASKTBALL_NCAA] = BASKETBALL_NCAA_SCORE_MAP;
scoreRepresentation[SportType.BEACH_VOLLEYBALL] = BEACH_VOLLEYBALL_SCORE_MAP;
scoreRepresentation[SportType.BIATHLON] = BIATHLON_SCORE_MAP;
scoreRepresentation[SportType.BOX] = BOXING_SCORE_MAP;
scoreRepresentation[SportType.CYBER_SPORTS_DOTA2] = CYBERSPORTDOTA2_SCORE_MAP;
scoreRepresentation[SportType.FOOTBALL] = FOOTBALL_SCORE_MAP;
scoreRepresentation[SportType.HANDBALL] = HANDBALL_SCORE_MAP;
scoreRepresentation[SportType.ICE_HOCKEY] = ICE_HOCKEY_SCORE_MAP;
scoreRepresentation[SportType.TABLE_TENNIS] = TABLE_TENNIS_SCORE_MAP;
scoreRepresentation[SportType.TENNIS] = TENNIS_SCORE_MAP;
scoreRepresentation[SportType.VOLLEYBALL] = VOLLEYBALL_SCORE_MAP;
scoreRepresentation[SportType.WATER_POLLO] = WATERPOLO_SCORE_MAP;
scoreRepresentation[SportType.WHAT_WHERE_WHEN] = WHATWHEREWHEN_SCORE_MAP;
scoreRepresentation[SportType.MARTIAL_ARTS] = MARTIAL_ART_SCORE_MAP;

export default class {

    static getGroupScores(match, groupTypeId, scores) {
        const groupScores = [];

        const realSportId = match.get('realSportId');

        const period = match.get('period');
        if (!period) {
            return groupScores;
        }

        const periodId = period.get('id');

        const sportPeriods = sportPeriodMap[realSportId];
        if (!sportPeriods) {
            return groupScores;
        }

        const matchPhase = sportPeriods[periodId];
        if (matchPhase === undefined) {
            return groupScores;
        }

        const sportScoresRepresentation = scoreRepresentation[realSportId];
        if (!sportScoresRepresentation) {
            return groupScores;
        }

        const matchPhaseScoreRepresentation = sportScoresRepresentation[matchPhase];

        if (!matchPhaseScoreRepresentation) {
            return groupScores;
        }

        const sportGroups = sportGroupMap[realSportId];
        if (!sportGroups) {
            return groupScores;
        }

        const sportGroupType = sportGroups[groupTypeId];

        if (sportGroupType === undefined) {
            return groupScores;
        }

        const groupScoreRepresentation = matchPhaseScoreRepresentation[sportGroupType];

        if (!groupScoreRepresentation) {
            return groupScores;
        }

        if (groupScoreRepresentation.info && matchPhase !== Period.FINISHED) {
            groupScores.push({
                type: MatchScoreType.INFO,
                value: groupScoreRepresentation.info
            });
        }

        if (groupScoreRepresentation.period_info &&
            (matchPhase >= Period.NOT_STARTED && matchPhase <= Period.FINISHED)) {
            groupScores.push({
                type: MatchScoreType.PERIOD_INFO,
                value: groupScoreRepresentation.period_info,
                sportId: realSportId,
                periodId
            });
        }

        if (!groupScoreRepresentation.main) {
            return groupScores;
        }

        const matchScores = match.get('scores');

        const scoreId = matchScores.get(groupScoreRepresentation.main);
        if (!scoreId) {
            return groupScores;
        }

        const mainScore = {
            type: MatchScoreType.MAIN,
            value: scores.get(scoreId)
        };

        groupScores.push(mainScore);

        if (groupScoreRepresentation.additional) {
            const additional = [];

            for (let i = 0; i < groupScoreRepresentation.additional.length; i++) {
                const scoreType = groupScoreRepresentation.additional[i];
                const score = scores.get(matchScores.get(scoreType));

                if (score && score.get('score1') !== null && score.get('score1') !== undefined &&
                    score.get('score2') !== null && score.get('score2') !== undefined) {
                    additional.push(score);
                }
            }

            if (additional.length > 0) {
                groupScores.push({
                    type: MatchScoreType.ADDITIONAL,
                    value: additional
                });
            }
        }

        if (groupScoreRepresentation.currentGame) {
            const currentGameScoreId = matchScores.get(groupScoreRepresentation.currentGame);

            if (currentGameScoreId) {
                groupScores.push({
                    type: MatchScoreType.CURRENT_GAME,
                    value: scores.get(currentGameScoreId)
                });
            }
        }

        if (groupScoreRepresentation.overtime) {
            const overtimeScoreId = matchScores.get(groupScoreRepresentation.overtime);

            if (overtimeScoreId) {
                groupScores.push({
                    type: MatchScoreType.OVERTIME,
                    value: scores.get(overtimeScoreId)
                });
            }
        }

        if (groupScoreRepresentation.fouls) {
            const foulsScoreId = matchScores.get(groupScoreRepresentation.fouls);

            if (foulsScoreId) {
                groupScores.push({
                    type: MatchScoreType.FOULS,
                    value: scores.get(foulsScoreId)
                });
            }
        }

        if (groupScoreRepresentation.possession) {
            const possessionScoreId = matchScores.get(groupScoreRepresentation.possession);

            if (possessionScoreId) {
                const score = scores.get(possessionScoreId);
                const team = score.get('team');
                if (team !== undefined) {
                    let mainScoreOffset = groupScores.indexOf(mainScore);

                    if (mainScoreOffset !== -1) {
                        mainScore.possession = team;
                        groupScores[mainScoreOffset] = mainScore;
                    }
                }
            }
        }

        if (groupScoreRepresentation.info && matchPhase === Period.FINISHED) {
            groupScores.push({
                type: MatchScoreType.INFO,
                value: groupScoreRepresentation.info
            });
        }

        if (groupScoreRepresentation.powerplay) {
            const powerPlayScoreId = matchScores.get(groupScoreRepresentation.powerplay);

            if (powerPlayScoreId) {
                const score = scores.get(powerPlayScoreId);
                const team = score.get('team');
                if (team !== undefined) {
                    let mainScoreOffset = groupScores.indexOf(mainScore);

                    if (mainScoreOffset !== -1) {
                        mainScore.powerplay = team;
                        groupScores[mainScoreOffset] = mainScore;
                    }
                }
            }
        }

        return groupScores;
    }
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/adapters/MatchScoresAdapter.js